export enum AutomationStatus {
	PENDING = "PEN",
	STARTED = "INI",
	PAUSED = "PAU",
	FINISHED = "FIN",
	DELETED = "DEL",
	ERROR_NOT_ENOUGH_QUOTE = "EQ1",
	ERROR_PAUSED_EXHAUSTED_QUOTA = "EQ2",
	ERROR_CONFIGURING_POOL_PROCESSES = "EP1",
}
